/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1UserUseridTemporaryPasswordMutationRequest,
  PostApiV1UserUseridTemporaryPasswordMutationResponse,
  PostApiV1UserUseridTemporaryPasswordPathParams,
  PostApiV1UserUseridTemporaryPassword400,
  PostApiV1UserUseridTemporaryPassword401,
  PostApiV1UserUseridTemporaryPassword500,
} from "../../types/userCredenciaisController/PostApiV1UserUseridTemporaryPassword.ts";

function getPostApiV1UserUseridTemporaryPasswordUrl(
  userId: PostApiV1UserUseridTemporaryPasswordPathParams["userId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/user/${userId}/temporary-password` as const,
  };
  return res;
}

/**
 * @description Define a senha temporária para um usuário. A senha é criptografada e a data de definição é registrada. Valida permissão de empresa do operador sobre o usuário alvo. Operadores com perfil Seller ou SellerManager não podem redefinir senhas de usuários com perfil diferente de Básico. **(Requer Authorization para autenticação)**
 * @summary Definir senha temporária do usuário (Requer Authorization para autenticação)
 * {@link /api/v1/user/:userId/temporary-password}
 */
export async function postApiV1UserUseridTemporaryPassword(
  userId: PostApiV1UserUseridTemporaryPasswordPathParams["userId"],
  data?: PostApiV1UserUseridTemporaryPasswordMutationRequest,
  config: Partial<
    RequestConfig<PostApiV1UserUseridTemporaryPasswordMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1UserUseridTemporaryPasswordMutationResponse,
    ResponseErrorConfig<
      | PostApiV1UserUseridTemporaryPassword400
      | PostApiV1UserUseridTemporaryPassword401
      | PostApiV1UserUseridTemporaryPassword500
    >,
    PostApiV1UserUseridTemporaryPasswordMutationRequest
  >({
    method: "POST",
    url: getPostApiV1UserUseridTemporaryPasswordUrl(userId).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
